// Exports
export default {
	"important": "important_EJt50",
	"responsiveButton": "responsiveButton_NaQey"
};
